import React from 'react';
import { Backdrop, Typography, Box, LinearProgress, Paper } from '@mui/material';
import './LoadingPopup.css';

const LoadingPage = ({ open = false, message = "Chargement en cours..." }) => {
  return (
    <Backdrop open={open} className="loading-backdrop">
      <Paper elevation={4} className="loading-paper">
        <Typography variant="h6" className="loading-message">
          {message}
        </Typography>
        <Box className="loading-bar-container">
          <LinearProgress className="loading-bar" />
        </Box>
      </Paper>
    </Backdrop>
  );
};

export default LoadingPage;
